export default __webpack_public_path__ + "static/media/cabonjy.8d5b2f74.png";